import { ViewLoaderIcon } from '@/client/assets';
import { memo } from 'react';

export const SpanLoading = memo(() => {
  return <ViewLoaderIcon className="size-[1em] animate-spin fill-current inline" />;
});

SpanLoading.displayName = 'SpanLoading';
